import React from 'react';
import CrossDeptTasksPage from '../CrossDeptTasksPage';

const PortalCrossDeptTasksPage = () => (
  <div className="max-w-7xl mx-auto px-4 py-6 pb-24">
    <CrossDeptTasksPage basePath="/portal/cross-dept-tasks" />
  </div>
);

export default PortalCrossDeptTasksPage;
